import { s } from '@/theme/tokens';
import { Stack } from '@/ui';
import { Box, Button, Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

type LandingHeroSectionProps = {
  headerWidth: number;
};

export const LandingHeroSection = ({ headerWidth }: LandingHeroSectionProps): ReactElement => (
  <Box
    component="section"
    sx={(theme) => ({
      position: 'relative',
      left: '50%',
      right: '50%',
      width: '100vw',
      ml: '-50vw',
      mr: '-50vw',
      px: s('none'),
      py: s('lg'),
      background: `linear-gradient(120deg, ${theme.app.colors.surfaceAlt} 0%, ${theme.app.colors.surface} 46%, ${theme.app.colors.primary}18 70%, ${theme.app.colors.surfaceAlt} 85%, ${theme.app.colors.surface} 100%)`,
    })}
  >
    <Box
      sx={{
        maxWidth: headerWidth,
        mx: 'auto',
        pt: `calc(${s('2xl')} + ${s('md')})`,
        pb: `calc(${s('3xl')} + ${s('2xl')})`,
        px: s('xl'),
      }}
    >
      <Stack gap="xl">
        <Text role="brand" component="h1" transform="none">
          FlowQA
        </Text>
        <Text role="pageTitle" component="h2" transform="none">
          Your Quality Operations, Analytics & Insights Layer
        </Text>
        <Text
          role="bodyMuted"
          component="p"
          mb="lg"
          sx={(theme) => ({ fontSize: theme.typography.h5.fontSize })}
        >
          Changing the way you view quality.
        </Text>
        <Box>
          <Button variant="primary" href="#request-early-access">
            Register Interest Today
          </Button>
        </Box>
      </Stack>
    </Box>
  </Box>
);
